
import Component from 'vue-class-component';
import Vue from 'vue';
import Header from '@/login/components/Header/Header.vue';
import Topbar from '@/login/components/Topbar/Topbar.vue';
import Modal from '@/login/components/Modal/Modal.vue';
import ErrorBar from '@/login/components/ErrorBar/ErrorBar.vue';
import { amplifyService } from '@kasasa/kloans-common-ui/dist/consumer-app/services/amplify';
import Loader from '@kasasa/kloans-common-ui/dist/consumer-app/components/Loader/Loader.vue';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component({
	components: {
		Header,
		Topbar,
		Modal,
		ErrorBar,
		Loader,
	},
})
export default class LoginLayout extends Vue {
	get showModal() {
		return this.$store.state.login.showModal;
	}

	get modalMessage() {
		return this.$store.state.login.modalText;
	}

	get showWell() {
		return this.$store.state.login.showWell;
	}

	get hasError() {
		return this.$store.state.login.hasError;
	}

	get hideConsumerLogin() {
		return this.$store.state.login.hideConsumerLogin;
	}

	get showLoader() {
		return this.$store.state.login.showLoader;
	}

	public async created() {
		await this.loadEnvironment();
	}

	private closeAppModal() {
		this.$store.commit('login/toggleModal');
	}

	private async loadEnvironment() {
		try {
			await amplifyService.initialize();
		} catch (error) {
			await this.$store.dispatch('login/showError', 'An error occurred, please reload the page and try again.');
		} finally {
			this.$store.commit('login/setLoaderState', false);
		}
	}
}

